export function isTrainingModeExemptUser(user) {
  if (!user) return false;
  if (user.superUser === true) return true;
  return user.role === "admin" || user.role === "supervisor";
}

export function isTrainingModeRestrictedUser(user) {
  return user?.trainingMode === true && !isTrainingModeExemptUser(user);
}
